import React from "react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import { paletteVar, Typography } from "@platform/design-system";

const PRIMARY_PURPLE = paletteVar("primary-main", "#832A80");

interface OfflineSubmissionToggleProps {
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export function OfflineSubmissionToggle({
  checked,
  onChange,
}: OfflineSubmissionToggleProps): React.JSX.Element {
  return (
    <Box sx={{ mt: 2 }}>
      <Typography variant="body-medium" sx={{ mb: 2 }}>
        Please select carriers and coverages you wish to send.
      </Typography>
      <FormControlLabel
        control={
          <Switch
            checked={checked}
            onChange={onChange}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: PRIMARY_PURPLE,
                filter:
                  "drop-shadow(0 2px 1px rgba(0, 0, 0, 0.20)) drop-shadow(0 1px 1px rgba(0, 0, 0, 0.14)) drop-shadow(0 1px 3px rgba(0, 0, 0, 0.12))",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: PRIMARY_PURPLE,
              },
            }}
          />
        }
        label="Offline Submission"
      />
    </Box>
  );
}
